import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { userImage, mtech } from "./../../../Assets/images/";
import logo from "../../../Assets/images/logo.png";
import { Navbar, Container, Nav, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomModal from "../../CustomModal";
import { useNavigate } from "react-router-dom";
import {
  faBell,
  faUser,
  faBars,
  faEllipsisV,
  faSignOut,
} from "@fortawesome/free-solid-svg-icons";

// import { notifications } from "../../../Config/Data";

import "./style.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchNotifications, markAllNotificationsAsRead, markSingleAsRead, dismissNotification } from "../../../store/slices/notificationSlice";
import axios from "axios";
import { toast } from "react-toastify";

export const Header = (props) => {
  const dispatch = useDispatch();
  const { items: notifications, unreadCount: totalUnreadNotifications } = useSelector(state => state.notifications);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const navigate = useNavigate();

  const Continue = () => {
    setShowModal(false);
    setShowModal2(true);
  };

  const handleClickPopup = () => {
    setShowModal(true);
  };

  const handleRedirect = () => {
    const LogoutData = localStorage.getItem("login");
    const device_token = localStorage.getItem("device_token") ?? '';


    fetch(`${process.env.REACT_APP_BASE_URL}/logout`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogoutData}`,
      },
      body: JSON.stringify({
        device_token: device_token,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        localStorage.removeItem("login");
        localStorage.removeItem("device_token");
        navigate("/");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const apiUrl = process.env.REACT_APP_BASE_URL;
  const imageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const LogoutData = localStorage.getItem("login");

  useEffect(() => {
    if (LogoutData) {
      dispatch(fetchNotifications());
    }
  }, [dispatch, LogoutData]);

  const [userData, setUserData] = useState();

  const PrfileDetail = () => {
    const LogoutData = localStorage.getItem("login");
    document.querySelector(".loaderBox").classList.remove("d-none");
    fetch(`${apiUrl}/admin/edit-profile`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogoutData}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(data?.data);
        document.querySelector(".loaderBox").classList.add("d-none");
        setUserData(data?.data);
      })
      .catch((error) => {
        document.querySelector(".loaderBox").classList.add("d-none");
        console.log(error);
      });
  };
  useEffect(() => {
    PrfileDetail();
  }, []);

  const markAllAsRead = (isOpen) => {
    if (isOpen && totalUnreadNotifications > 0) {
      dispatch(markAllNotificationsAsRead());
    }
  };

  const getNotificationLink = (notification) => {
    const title = notification?.data?.title?.toLowerCase() || "";
    const body = notification?.data?.body?.toLowerCase() || "";
    const orderId = notification?.data?.order_id;
    const reviewId = notification?.data?.review_id;

    if (title.includes("order") || body.includes("order")) {
      return orderId ? `/orders/${orderId}` : "/orders";
    } 
    
    if (title.includes("review") || body.includes("review")) {
      return reviewId ? `/reviews/${reviewId}` : "/reviews";
    } 
    
    if (title.includes("query") || title.includes("contact") || body.includes("query") || body.includes("contact")) {
      return "/contact-queries";
    }
    
    return "/dashboard";
  };

  const handleNotificationClick = (notification) => {
    const targetLink = getNotificationLink(notification);
    const title = notification?.data?.title?.toLowerCase() || "";
    
    // Logic for "Review not found" or missing IDs
    if ((title.includes("review") && !notification?.data?.review_id) || 
        (title.includes("order") && !notification?.data?.order_id)) {
      if (title.includes("detail") || title.includes("new")) {
         toast.info("Opening list (specific ID not found in notification)", {
           toastId: "missing-id-alert"
         });
      }
    }

    // Mark as read immediately (optimistic disappearance)
    if (!notification.read_at) {
      dispatch(dismissNotification(notification.id));
      dispatch(markSingleAsRead(notification.id));
    }

    // Perform navigation
    navigate(targetLink);
  };
  return (
    <header>
      <Navbar className="customHeader" expand="md">
        <Container fluid>
          <button className="notButton ms-md-2 fs-5 order-1">
            <FontAwesomeIcon
              className="bell-icon"
              onClick={props.sidebarToggle}
              icon={faBars}
            />
          </button>
          <Link
            to={"/dashboard"}
            className="siteLogo order-2 order-lg-3 text-decoration-none"
          >
            {/* <h1>Project <span>Camp</span></h1> */}
            <img src={logo} className="mw-100" />
          </Link>
          <Navbar.Toggle className="order-4 order-lg-2 notButton">
            <FontAwesomeIcon className="bell-icon" icon={faEllipsisV} />
          </Navbar.Toggle>
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="customCollapse order-3"
          >
            <Nav className="ms-auto">
              <Dropdown className="notiDropdown me-2">
                <Dropdown.Toggle variant="transparent" className="notButton">
                  <div className="position-relative">
                    <span className="notification-count">
                      {totalUnreadNotifications}
                    </span>

                    <FontAwesomeIcon className="bellIcon" icon={faBell} />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="notiMenu" align="end">
                  <div className="notiHead p-3 pb-0 d-flex justify-content-between align-items-center">
                    <h4 className="mainTitle mb-0">Notifications</h4>
                    {totalUnreadNotifications > 0 && (
                      <button 
                        className="btn btn-link btn-sm text-decoration-none p-0" 
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(markAllNotificationsAsRead());
                        }}
                        style={{ fontSize: '12px', color: 'var(--primaryColor)' }}
                      >
                        Mark all
                      </button>
                    )}
                  </div>
                  <div className="notificationsBody">
                    {totalUnreadNotifications > 0 ? (
                      notifications
                        .filter(n => !n.read_at)
                        .slice(0, 10) // Show only latest 10 unread to keep dropdown clean
                        .map((notification) => (
                        <div
                          key={notification.id}
                          className="singleNoti unread"
                          onClick={() => handleNotificationClick(notification)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="singleNotiIcon">
                            <FontAwesomeIcon
                              className="notiIcon"
                              icon={faBell}
                            />
                            <span className="notiUnreadDot ms-1"></span>
                          </div>
                          <div className="singleNotiContent">
                            <p className="notiText">
                              {notification?.data?.title}
                            </p>
                            <p className="notiBody">
                              {notification?.data.body}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="notiEmptyState">
                        <svg className="notiEmptyIcon notiEmptyAppear" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="32" cy="32" r="30" stroke="#2a4a7f" strokeWidth="2" fill="rgba(2,82,201,0.07)" />
                          <path d="M32 14C25.373 14 20 19.373 20 26v9l-3 4h30l-3-4v-9c0-6.627-5.373-12-12-12z" stroke="#2a4a7f" strokeWidth="1.8" strokeLinejoin="round" fill="none" />
                          <path d="M29 43a3 3 0 006 0" stroke="#2a4a7f" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>
                        <p className="notiEmptyTitle">You're all caught up!</p>
                        <p className="notiEmptySubtext">New notifications will appear here when there's activity on the platform.</p>
                      </div>
                    )}
                  </div>
                  {/* <div className="notiFooter">
                    <Link to={"/notifications"}>View All</Link>
                  </div> */}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="userDropdown">
                <Dropdown.Toggle
                  variant="transparent"
                  className="notButton toggleButton"
                >
                  <div className="userImage">
                    <img
                      src={`${imageUrl}/${userData?.image}`}
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  {/* <img src={images.profilePic} alt="" className="img-fluid" /> */}
                </Dropdown.Toggle>
                <Dropdown.Menu className="userMenu" align="end">
                  <Link className="userMenuItem" to={"/profile"}>
                    <FontAwesomeIcon
                      className="me-2 yellow-text"
                      icon={faUser}
                    />{" "}
                    Profile
                  </Link>
                  <Link
                    to="#"
                    className="userMenuItem"
                    onClick={handleClickPopup}
                  >
                    <FontAwesomeIcon
                      className="me-1 yellow-text"
                      icon={faSignOut}
                    />{" "}
                    Logout
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>

        </Container>
      </Navbar>

      <CustomModal
        show={showModal}
        close={() => {
          setShowModal(false);
        }}
        action={Continue}
        heading="Are you sure you want to logout?"
      />
      <CustomModal
        show={showModal2}
        close={handleRedirect}
        success
        heading="Successfully Logged Out"
      />
    </header>
  );
};
